/**
 * Get Module Action Name
 * @param {string} moduleName
 */
export const getModuleActionName = (moduleName: string) => (actionName: string) => `[${moduleName}] ${actionName}`;
